(function($) {
    $(function() {
        $('.load_more:not(.loading)').on('click', function(e) {
            e.preventDefault();
            var $load_more_btn = $(this);
            var post_type = 'post';
            var offset = $('.blog .related-news-wrapper .one-post').length;
            $.ajax({
                type: "post",
                context: this,
                dataType: "json",
                url: delizia_localize.ajaxurl,
                data: {
                    action: "load_more",
                    offset: offset,
                    post_type: post_type,
                    //posts_per_page: delizia_localize.posts_per_page
                    posts_per_page: 3
                },
                beforeSend: function(data) {
                    $load_more_btn.find('.btn-text').css('opacity','0').addClass('loading');
                    $load_more_btn.find('.preloader').fadeIn(400);
                },
                success: function(response) {
                    if (response['have_posts'] == 1) {
                        $load_more_btn.find('.btn-text').css('opacity','1');
                        $load_more_btn.find('.preloader').fadeOut(400);
                        $load_more_btn.removeClass('loading');
                        $load_more_btn.find('.btn-text').html(delizia_localize.morenews);
                        var $newElems = $(response['html'].replace(/(\r\n|\n|\r)/gm, ''));
                        $newElems.hide().appendTo('.blog .related-news-wrapper').fadeIn(500);
                        $('body .related-news .picture-infos').matchHeight({})
                    } else {
                        $load_more_btn.removeClass('loading').addClass('end_of_posts').html('<span>'+delizia_localize.nomore+'</span>');
                    }
                }
            });
        });

    });
})(jQuery);
